import { BASE_URL } from 'constants/api';

import actions from './index';
import { stringify } from 'query-string';

export const ACTIONS = {
  GET_ALL: 'TEACHER_MAPPING_GET_ALL',
  GET_ALL_SUCCESS: 'TEACHER_MAPPING_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'TEACHER_MAPPING_GET_ALL_FAILURE',
  GET: 'TEACHER_MAPPING_PARAM_OPTION',
  GET_SUCCESS: 'TEACHER_MAPPING_PARAM_OPTION_SUCCESS',
  GET_FAILURE: 'TEACHER_MAPPING_PARAM_OPTION_FAILURE',
};

export const getAll = actions.getAll(
  query => `${BASE_URL}/demo/teacher-mapper/?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);
export const get = actions.get(
  studentId => `${BASE_URL}/configs/teacher_mapping_param_options`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
